import React from "react";
import { getSecureItem } from "../../../utilsFunctions";
import { ImageBaseUrl } from "../../../Environment";
import pdfMake from "../pdfmakeWrapper";

// Convert image URL to base64
function getBase64ImageFromUrl(url) {
  return fetch(url, { mode: "cors" })
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.blob();
    })
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
}

const PdfReportCA = ({
  sortedData,
  fourBlockData,
  selectedBorrower,
  dateRange,
  loanStatus,
  loanPaymentStatus,
  loanTenure,
  companyData,
}) => {
  const getAddress = (address) =>
    [
      address?.AddressStreet,
      address?.AddressLandmark,
      address?.AddressCity,
      address?.AddressState,
      address?.AddressPincode,
    ]
      .filter(Boolean)
      .join(", ");

  const imageUrl =
    getSecureItem("loggedinUserCompany") === "1365"
      ? "https://i.imghippo.com/files/CCD2780qQ.jpeg"
      : `${ImageBaseUrl}${companyData?.profilePic}`;

  getBase64ImageFromUrl(imageUrl)
    .then((imageBase64) => buildAndDownloadPdf(imageBase64))
    .catch((err) => {
      console.warn("Image load failed, continuing without logo:", err);
      buildAndDownloadPdf(null);
    });

  function buildAndDownloadPdf(imageBase64) {
    const headerSection = [
      {
        table: {
          widths: ["*"],
          body: [
            [
              {
                columns: [
                  imageBase64
                    ? { image: imageBase64, width: 60, height: 70 }
                    : {
                        text: "LOGO",
                        width: 60,
                        height: 70,
                        alignment: "center",
                        color: "#aaa",
                      },
                  {
                    width: "*",
                    alignment: "center",
                    stack: [
                      { text: companyData.companyName, style: "companyName" },
                      {
                        text: `Address: ${getAddress(companyData.address)}`,
                        style: "infoText",
                      },
                      {
                        text: `GSTIN: ${companyData.GstIn || ""} | Website: ${companyData.companyWebsite || ""}`,
                        style: "infoText",
                      },
                      {
                        text: `Mobile No: ${companyData.phone} | Email ID: ${companyData.companyMail}`,
                        style: "infoText",
                      },
                    ],
                  },
                ],
                columnGap: 10,
              },
            ],
          ],
        },
        layout: { hLineWidth: () => 1, vLineWidth: () => 1 },
        margin: [0, 0, 0, 10],
      },
    ];

    const filterSection = [
      { text: "Collection-Agent Wise Report", style: "title" },
      { text: `Collection Agent: ${selectedBorrower}`, style: "filter" },
      { text: `Loan Status: ${loanStatus}`, style: "filter" },
      { text: `Payment Status: ${loanPaymentStatus}`, style: "filter" },
      { text: `Sequence: ${loanTenure}`, style: "filter" },
      {
        text: `Date Range: ${
          dateRange?.start && dateRange?.end
            ? `${dateRange.start} - ${dateRange.end}`
            : "Life-Time"
        }`,
        style: "filter",
        margin: [0, 0, 0, 20],
      },
    ].map((item) => ({ ...item, alignment: "center" }));

    const fourBlockRow = {
      table: {
        widths: ["25%", "25%", "25%", "25%"],
        body: [
          fourBlockData.map((item) => ({
            stack: [
              { text: item.heading, style: "fourBlockHeading" },
              { text: item.value, style: "fourBlockValue" },
            ],
            alignment: "center",
            style: "fourBlock",
          })),
        ],
      },
      layout: { hLineWidth: () => 1, vLineWidth: () => 1 },
      margin: [0, 0, 0, 10],
    };

    const tableHeaders = [
      "Sr. No.",
      "Loan ID",
      "Borrower",
      "Lent",
      "Collected",
      "Penalty",
      "Balance",
      "Remaining Dues",
    ];

    const tableBody = [
      tableHeaders.map((header) => ({
        text: header,
        style: "tableHeader",
        alignment: "center",
      })),
      ...sortedData.map((data, index) => {
        const borrowerName = `${data?.customer?.firstName} ${data?.customer?.lastName}`;
        const custId = data?.customer?.cust_id
          ? ` (${data?.customer?.cust_id})`
          : "";
        return [
          index + 1,
          data.loanId,
          borrowerName + custId,
          data.loanAmount,
          data.totalCollectionAmount,
          data.totalPenaltyApplied,
          data.balanceAmount,
          data.pendingDues,
        ];
      }),
    ];

    const docDefinition = {
      content: [
        ...headerSection, // array
        ...filterSection, // array
        fourBlockRow, // object
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "*", "*", "*", "*", "*", "*"],
            body: tableBody,
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? "#f0f0f0" : null),
          },
          dontBreakRows: false,
        },
      ],
      styles: {
        title: {
          fontSize: 16,
          bold: true,
          marginBottom: 10,
        },
        filter: {
          fontSize: 10,
          marginBottom: 2,
        },
        companyName: {
          fontSize: 14,
          bold: true,
          marginBottom: 4,
          marginTop: 5,
        },
        infoText: {
          fontSize: 9,
          lineHeight: 1.3,
        },
        tableHeader: {
          fontSize: 10,
          bold: true,
        },
        fourBlockHeading: {
          fontSize: 11,
          bold: true,
          margin: [0, 5, 0, 2],
        },
        fourBlockValue: {
          fontSize: 10,
          margin: [0, 2, 0, 5],
        },
        fourBlock: {
          margin: [0, 5, 0, 5],
        },
      },
      defaultStyle: {
        alignment: "center",
        fontSize: 9,
      },
      pageMargins: [10, 10, 10, 10],
    };

    pdfMake.createPdf(docDefinition).download("CollectionAgentWiseReport.pdf");
  }
};

export default PdfReportCA;
